import { convertDateToTimeZone, prepareTime } from 'infrastructure/functions';
import { addDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { between } from 'infrastructure/functions/between';
import { Timezones } from 'infrastructure/enums';

import type { Nullable } from 'infrastructure/types';

export const isInDoNotCallWindow = (
  startTime: string,
  endTime: string,
  pTZ: Nullable<string> = Timezones['America/Chicago'],
) => {
  const parsedStartTime = prepareTime(startTime);
  const parsedEndTime = prepareTime(endTime);
  if (parsedStartTime && parsedEndTime) {
    const patientTime = pTZ
      ? convertDateToTimeZone(new Date(), pTZ)
      : new Date();
    const [startHours, startMinutes] = parsedStartTime.split(':');
    const [endHours, endMinutes] = parsedEndTime.split(':');
    const sTime = setHours(
      setMinutes(setSeconds(patientTime, 0), +startMinutes),
      +startHours,
    );
    let eTime = setHours(
      setMinutes(setSeconds(patientTime, 0), +endMinutes),
      +endHours,
    );
    if (sTime.getTime() > eTime.getTime()) eTime = addDays(eTime, 1);

    const isRestricted = between(
      patientTime.getTime(),
      sTime.getTime(),
      eTime.getTime(),
    );

    return isRestricted;
  }

  return false;
};
